// extracted by mini-css-extract-plugin
export default {"button":"DefaultControl_button__tnTh9"};